import { create } from 'zustand';

export type ConnectionStatus = 'connecting' | 'open' | 'closed' | 'stale';
export type Theme = 'dark' | 'light';

interface UiState {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  closeSidebar: () => void;
  openSidebar: () => void;

  theme: Theme;
  setTheme: (theme: Theme) => void;

  connectionStatus: ConnectionStatus;
  setConnectionStatus: (status: ConnectionStatus) => void;
}

/**
 * Zustand: UI-only state (sidebar drawer, theme, websocket connection
 * banner). Server data (torrents, activity, health) lives in TanStack
 * Query, not here — see docs/architecture/system-architecture.md#2.
 */
export const useUiStore = create<UiState>((set) => ({
  sidebarOpen: false,
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  closeSidebar: () => set({ sidebarOpen: false }),
  openSidebar: () => set({ sidebarOpen: true }),

  theme: 'dark',
  setTheme: (theme) => set({ theme }),

  connectionStatus: 'connecting',
  setConnectionStatus: (status) => set({ connectionStatus: status }),
}));
